var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=isBuffer.js.map
